import React from 'react';
import './Header.css';

function Header({ breadcrumbs = [], onNavigate }) {
  // Get the back action from the last clickable breadcrumb
  const backAction = breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2]?.onClick : breadcrumbs[0]?.onClick;
  const showBackButton = breadcrumbs.length > 1 && backAction;

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-nav-container">
          {showBackButton && (
            <button className="header-back-button" onClick={backAction}>
              ← Back
            </button>
          )}
          <div className="breadcrumb-nav">
            {breadcrumbs.map((crumb, index) => (
              <span key={index} className="breadcrumb-item">
                {index > 0 && <span className="breadcrumb-separator">›</span>}
                {crumb.onClick ? (
                  <button
                    className="breadcrumb-link"
                    onClick={crumb.onClick}
                  >
                    {crumb.label}
                  </button>
                ) : (
                  <span className="breadcrumb-current">{crumb.label}</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
